import api from '../token';

export const ListArmazem = async () => {
  try {
    const response = await api.post('/getArmazem');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

